module.exports = require("@gauzy/constants");